import { call, put, takeLatest } from 'redux-saga/effects';
import * as actionTypes from '../actions/actionsType';
import { setLessonsCardsStart, setLoading } from '../actions';
import { setOpenErrorSnackbar } from '../actions/snackbar';
import { createErrorMessage } from '../utils/sagaUtils';
import { GET } from '../constants/methods';
import { LESSON_URL } from '../constants/axios';
import { axiosCall } from '../services/axios';

export function* getLessonsByGroup({ id }) {
    try {
        yield put(setLoading(true));

        const requestUrl = `${LESSON_URL}?groupId=${Number(id)}`;
        const { data } = yield call(axiosCall, requestUrl, GET, id);

        yield put(setLessonsCardsStart(data));
    } catch (error) {
        yield put(setOpenErrorSnackbar(createErrorMessage(error)));
    } finally {
        yield put(setLoading(false));
    }
}

export default function* watchLessons() {
    yield takeLatest(actionTypes.GET_LESSONS_CARDS_START, getLessonsByGroup);
}
